export const data = [
    {
        question: "What is the capital of France?",
        option1: "Berlin",
        option2: "Madrid",
        option3: "Paris",
        option4: "Lisbon",
        correctAnswer: 3
    },
    {
        question: "Which planet is known as the Red Planet?",
        option1: "Earth",
        option2: "Mars",
        option3: "Jupiter",
        option4: "Saturn",
        correctAnswer: 2
    },
    {
        question: "Who wrote 'Hamlet'?",
        option1: "Charles Dickens",
        option2: "Leo Tolstoy",
        option3: "William Shakespeare",
        option4: "Mark Twain",
        correctAnswer: 3
    },
    {
        question: "Which ocean is the largest?",
        option1: "Atlantic",
        option2: "Indian",
        option3: "Arctic",
        option4: "Pacific",
        correctAnswer: 4
    },
    {
        question: "What is the tallest mountain in the world?",
        option1: "K2",
        option2: "Mount Kilimanjaro",
        option3: "Mount Everest",
        option4: "Denali",
        correctAnswer: 3
    },
    {
        question: "Which element has the chemical symbol 'O'?",
        option1: "Oxygen",
        option2: "Gold",
        option3: "Osmium",
        option4: "Oganesson",
        correctAnswer: 1
    },
    {
        question: "What is the largest country by area?",
        option1: "Canada",
        option2: "China",
        option3: "Russia",
        option4: "USA",
        correctAnswer: 3
    },
    {
        question: "In which year did the Titanic sink?",
        option1: "1912",
        option2: "1905",
        option3: "1921",
        option4: "1898",
        correctAnswer: 1
    },
    {
        question: "Who was the first President of the United States?",
        option1: "Abraham Lincoln",
        option2: "George Washington",
        option3: "Thomas Jefferson",
        option4: "John Adams",
        correctAnswer: 2
    },
    {
        question: "Which country is known as the Land of the Rising Sun?",
        option1: "China",
        option2: "Japan",
        option3: "Thailand",
        option4: "South Korea",
        correctAnswer: 2
    },
    {
        question: "What is the smallest prime number?",
        option1: "1",
        option2: "2",
        option3: "3",
        option4: "5",
        correctAnswer: 2
    },
    {
        question: "Which continent is the Sahara Desert located on?",
        option1: "Asia",
        option2: "Australia",
        option3: "Africa",
        option4: "South America",
        correctAnswer: 3
    },
    {
        question: "Which is the largest mammal?",
        option1: "Elephant",
        option2: "Blue Whale",
        option3: "Giraffe",
        option4: "Hippopotamus",
        correctAnswer: 2
    },
    {
        question: "What is the capital of Australia?",
        option1: "Sydney",
        option2: "Melbourne",
        option3: "Canberra",
        option4: "Perth",
        correctAnswer: 3
    },
    {
        question: "Who invented the telephone?",
        option1: "Thomas Edison",
        option2: "Nikola Tesla",
        option3: "Alexander Graham Bell",
        option4: "Guglielmo Marconi",
        correctAnswer: 3
    },
    {
        question: "Which vitamin is known as the sunshine vitamin?",
        option1: "Vitamin A",
        option2: "Vitamin B12",
        option3: "Vitamin C",
        option4: "Vitamin D",
        correctAnswer: 4
    },
    {
        question: "What is the smallest unit of life?",
        option1: "Cell",
        option2: "Atom",
        option3: "Molecule",
        option4: "Organ",
        correctAnswer: 1
    },
    {
        question: "Which gas is most abundant in Earth's atmosphere?",
        option1: "Oxygen",
        option2: "Carbon Dioxide",
        option3: "Nitrogen",
        option4: "Hydrogen",
        correctAnswer: 3
    },
    {
        question: "Who painted the Mona Lisa?",
        option1: "Vincent van Gogh",
        option2: "Pablo Picasso",
        option3: "Leonardo da Vinci",
        option4: "Claude Monet",
        correctAnswer: 3
    },
    {
        question: "What is the hardest natural substance on Earth?",
        option1: "Gold",
        option2: "Iron",
        option3: "Diamond",
        option4: "Platinum",
        correctAnswer: 3
    }
];

